import { AnyAction } from 'redux';
import {
  CreateAccountDto,
  GetAccountDto,
  PatchAccountDto,
  PatchJointAccountInterestDto,
  PatchAccountBeneficiariesDto,
  SubmitAccountDto,
  SwitchAccountDto,
  UpdateAccountSignatureDto,
  UpdateAccountSuitabilityInformationDto,
  UpdateAccountFinancialAssetsDto,
  LinkAccountDto,
} from 'src/dtos';
import { Account } from 'src/models';

import { createAction, State, Type } from './utils';

export const doGetAccount = (payload: GetAccountDto): AnyAction =>
  createAction(State.actionRequested(Type.GET_ACCOUNT), payload);

export const doSucceededGetAccount = (payload: any): AnyAction =>
  createAction(State.actionSucceeded(Type.GET_ACCOUNT), payload);

export const doClearGetAccount = (): AnyAction => createAction(State.actionCleared(Type.GET_ACCOUNT));

export const doRefreshAccount = (payload: GetAccountDto): AnyAction =>
  createAction(State.actionRequested(Type.REFRESH_ACCOUNT), payload);

export const doSucceededRefreshAccount = (payload: any): AnyAction =>
  createAction(State.actionSucceeded(Type.REFRESH_ACCOUNT), payload);

export const doClearRefreshAccount = (): AnyAction => createAction(State.actionCleared(Type.REFRESH_ACCOUNT));

export const doFailedRefreshAccount = (payload: GetAccountDto): AnyAction =>
  createAction(State.actionFailed(Type.REFRESH_ACCOUNT), payload);

export const doCreateAccount = (payload: CreateAccountDto): AnyAction =>
  createAction(State.actionRequested(Type.CREATE_ACCOUNT), payload);

export const doClearCreateAccount = (): AnyAction => createAction(State.actionCleared(Type.CREATE_ACCOUNT));

export const doPatchAccount = (payload: PatchAccountDto): AnyAction =>
  createAction(State.actionRequested(Type.PATCH_ACCOUNT), payload);

export const doClearPatchAccount = (): AnyAction => createAction(State.actionCleared(Type.PATCH_ACCOUNT));

export const doPatchJointAccountInterest = (payload: PatchJointAccountInterestDto): AnyAction =>
  createAction(State.actionRequested(Type.PATCH_JOINT_ACCOUNT_INTEREST), payload);

export const doClearPatchJointAccountInterest = (): AnyAction =>
  createAction(State.actionCleared(Type.PATCH_JOINT_ACCOUNT_INTEREST));

export const doPatchAccountBeneficiaries = (payload: PatchAccountBeneficiariesDto): AnyAction =>
  createAction(State.actionRequested(Type.PATCH_ACCOUNT_BENEFICIARIES), payload);

export const doClearPatchAccountBeneficiaries = (): AnyAction =>
  createAction(State.actionCleared(Type.PATCH_ACCOUNT_BENEFICIARIES));

// Suitability Information
export const doUpdateAccountSuitabilityInformation = (payload: UpdateAccountSuitabilityInformationDto): AnyAction => {
  return createAction(State.actionRequested(Type.UPDATE_ACCOUNT_SUITABILITY_INFORMATION), payload);
};

export const doClearUpdateAccountSuitabilityInformation = (): AnyAction =>
  createAction(State.actionCleared(Type.UPDATE_ACCOUNT_SUITABILITY_INFORMATION));

// Financial Information
export const doUpdateAccountFinancialAssets = (payload: UpdateAccountFinancialAssetsDto): AnyAction => {
  return createAction(State.actionRequested(Type.UPDATE_ACCOUNT_FINANCIAL_ASSETS), payload);
};

export const doClearUpdateAccountFinancialAssets = (): AnyAction =>
  createAction(State.actionCleared(Type.UPDATE_ACCOUNT_FINANCIAL_ASSETS));

export const doSubmitAccount = (payload: SubmitAccountDto): AnyAction =>
  createAction(State.actionRequested(Type.SUBMIT_ACCOUNT), payload);

export const doClearSubmitAccount = (): AnyAction => createAction(State.actionCleared(Type.SUBMIT_ACCOUNT));

export const doUpdateAccountSignature = (payload: UpdateAccountSignatureDto): AnyAction =>
  createAction(State.actionRequested(Type.UPDATE_ACCOUNT_SIGNATURE), payload);

export const doClearUpdateAccountSignature = (): AnyAction =>
  createAction(State.actionCleared(Type.UPDATE_ACCOUNT_SIGNATURE));

export const doFailedUpdateAccountSignature = (payload: any): AnyAction =>
  createAction(State.actionFailed(Type.UPDATE_ACCOUNT_SIGNATURE), payload);

export const doSucceededUpdateAccountSignature = (payload: Account): AnyAction =>
  createAction(State.actionSucceeded(Type.UPDATE_ACCOUNT_SIGNATURE), payload);

export const doSwitchAccount = (payload: SwitchAccountDto): AnyAction =>
  createAction(State.actionRequested(Type.SWITCH_ACCOUNT), payload);

export const doClearSwitchAccount = (): AnyAction => createAction(State.actionCleared(Type.SWITCH_ACCOUNT));

export const doLinkAccount = (payload: LinkAccountDto): AnyAction =>
  createAction(State.actionRequested(Type.LINK_ACCOUNT), payload);

export const doSucceededLinkAccount = (payload: Account): AnyAction =>
  createAction(State.actionSucceeded(Type.LINK_ACCOUNT), payload);

export const doFailedLinkAccount = (payload: any): AnyAction =>
  createAction(State.actionFailed(Type.LINK_ACCOUNT), payload);

export const doClearLinkAccount = (): AnyAction => createAction(State.actionCleared(Type.LINK_ACCOUNT));
